// import logo from './logo.svg';
// import './App.css';
import { createPortal } from 'react-dom';
import DeliveryCountdown from './DeliveryCountdown';

function CountdownPortal(props) {
  return createPortal(
    <DeliveryCountdown {...props} />,
    props.selector
  );
}

export default CountdownPortal;
